const _ = require('lodash');

class PickupAddressListController {
    constructor($scope, $element, addressService, stateService, moveFocus) {
        this.$scope = $scope;
        this.$element = $element;
        this.stateService = stateService;
        this.moveFocus = moveFocus;

        this.updatePickupStores = _.debounce((selectedState) => {
            this.isSearching = true;
            this.hasSearched = true;
            const args = selectedState && selectedState.Code
                ? { state: selectedState.Code }
                : undefined;
            addressService.getPickupAddresses(args)
                .then((pickupStores) => {
                    this.isSearching = false;
                    this.setStores({ stores: pickupStores });
                });
        }, 500);

        $scope.$watch(
            () => this.states.selectedState,
            () => this.updatePickupStores(this.states.selectedState));
    }

    $onInit() {
        this.states = {
            states: [],
            selectedState: null,
        };

        this.moveFocus(this.$element.find('._pickupAddressList-stateSelect'));

        this.stateService.getStates().then((states) => {
            let selectedState = _.find(states, 'IsStateForDeliveryAddress');

            if (!selectedState) {
                selectedState = _.first(states);
            }

            this.states = {
                states,
                selectedState,
            };
        });
    }
}

const pickupAddressListComponentDefinition = {
    bindings: {
        hasSearched: '=',
        isSearching: '=',
        pickupStores: '=',
        setStores: '&',
    },
    controller: ['$scope', '$element', 'AddressService', 'StateService', 'MoveFocus', PickupAddressListController],
    template: require('./pickup-address-list.component.html').trim(),
};

module.exports = {
    PickupAddressListController,
    pickupAddressListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/pickup-address-list.component.js